import { ChangeDetectionStrategy, Component, forwardRef, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { TextParserService } from 'src/app/shared/services/text-parser-service.service';

@Component({
  selector: 'app-trending-viunify-modal',
  templateUrl: './trending-viunify-modal.component.html',
  styleUrl: './trending-viunify-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    forwardRef(() => CommonStandaloneModule),
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatDialogClose,
  ],
})
export class TrendingViUnifyModalComponent implements OnInit {
  textContent: { type: string; content: string }[] = [];
  constructor(
    private dialogRef: MatDialogRef<TrendingViUnifyModalComponent>,
    private textParserService: TextParserService,
    private translation: TranslateService
  ) {}

  ngOnInit(): void {
    const textTranslation = this.translation.instant(
      '+INSTALLATIONS.INSTALLATION.TRENDING.VIUNIFY_MODAL.CONTENT'
    );
    const keyTranslation = this.translation.instant(
      '+INSTALLATIONS.INSTALLATION.TRENDING.VIUNIFY_MODAL.KEY_TRANSLATION'
    );

    this.textContent = this.textParserService.parseTextContent(textTranslation, keyTranslation);
    this.dialogRef.updateSize('768px');
  }
}
